import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import NavbarLocal from 'Components/Admin/NavbarLocal';
import CashFlows from './tabs/CashFlows/CashFlows';
import IncomeStatement from './tabs/IncomeStatement/IncomeStatement';
import withErrorBoundary from 'Components/ErrorBoundary/ErrorBoundary';
import { routes } from './routes/routes';
import { ADMIN_URL } from '../Admin/constants/constants';
import AppSwitch from 'Components/AppSwitch';

function Reporting() {
  return (
    <div className="reporting">
      <div className="reporting__header">
        <NavbarLocal routes={routes} />
      </div>
      <div className="reporting__main">
        <AppSwitch>
          <Route
            path={`/${ADMIN_URL}/reporting/`}
            exact
            render={() => <Redirect to={`/${ADMIN_URL}/reporting/cash-flows/`} />}
          />
          <Route
            path={`/${ADMIN_URL}/reporting/cash-flows/`}
            render={(routeProps) => <CashFlows titleColumn={'Breakdown'} {...routeProps} />}
          />
          <Route
            path={`/${ADMIN_URL}/reporting/income-statement/`}
            render={(routeProps) => <IncomeStatement titleColumn={'Breakdown'} {...routeProps} />}
          />
          <Route path={`/${ADMIN_URL}/reporting/sales/`} render={() => <div>22</div>} />
          <Route path={`/${ADMIN_URL}/reporting/assets/`} render={() => <div>33</div>} />
          <Route path={`/${ADMIN_URL}/reporting/waste/`} render={() => <div>44</div>} />
          <Route path={`/${ADMIN_URL}/reporting/misc-expenses/`} render={() => <div>55</div>} />
          <Route path={`/${ADMIN_URL}/reporting/project-expenses/`} render={() => <div>66</div>} />
        </AppSwitch>
      </div>
    </div>
  );
}

export default withErrorBoundary(Reporting);
